import { gsap } from 'gsap';

const serviceButtons = document.getElementsByClassName('p-service__items');

if (serviceButtons) {
  Array.from(serviceButtons).forEach(button => {

    const inner = button.querySelector('.p-service__items__inner');
    const res = (value) => {
      return `clamp(${value * .66 + 'px'}, ${value / 1920 * 100 + 'vw'}, ${value + 'px'})`;
    }

    const serviceHover = gsap.timeline({
      paused: true
    })
      // .from(button, {
      //   width: res(120),
      //   duration: .2,
      //   ease: "expo.inOut"
      // })
      .to(button, {
        width: res(686),
        duration: .4,
        ease: "expo.inOut"
      }, '<')
      .to(inner, {
        backgroundPosition: '0 100%',
        duration: .4,
      }, '<')

    if (window.matchMedia('(min-width: 1025px)').matches) {
      inner.addEventListener("mouseenter", function () {
        serviceHover.play();
      });

      inner.addEventListener("mouseleave", function () {
        serviceHover.reverse();
      });
    }
  });
}

// Zoom
const zoomImgs = document.getElementsByClassName('js-zoom-media__picture');
if (zoomImgs) {
  Array.from(zoomImgs).forEach(img => {
    const inner = img.querySelector('.js-zoom-media');
    img.style.overflow = 'hidden';

    const imgHover = gsap.timeline({
      paused: true
    })
      .to(inner, {
        scale: 1.1,
        duration: .4,
        ease: 'expo.inOut'
      }, '<')

    img.addEventListener("mouseenter", function () {
      imgHover.play();
    });

    img.addEventListener("mouseleave", function () {
      imgHover.reverse();
    });
  })
}